import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { State } from "../../redux/store";
import { InstructionInterface } from "../instructions/types";
import { useTranslation } from "react-i18next";
import { ShowFrontEndContext } from "./types";
import { pageDirContext } from "../../App";

const ShowInstructions: React.FC = () => {
  const { instructions } = useSelector((state: State) => state.instructions);
  const { t } = useTranslation();
  const { InstructionRef } = useContext(ShowFrontEndContext);

  const { pageDir } = useContext(pageDirContext);

  return (
    <section
      className="my-6 p-6 bg-gray-100 rounded-lg shadow-md"
      ref={InstructionRef}
      dir={pageDir}
    >
      {/* Title - Centered */}
      <h2 className="text-main text-center font-bold text-xl md:text-2xl mb-4 border-b-2 border-main pb-2">
        {t("Instructions de l'ONMDM")}
      </h2>

      {/* Instruction List */}
      <div className="grid md:grid-cols-2 gap-4">
        {instructions.map((instruction: InstructionInterface, index: number) => (
          <div
            key={index}
            className={`relative bg-white rounded-lg p-6 shadow flex flex-col md:flex-row items-center md:items-start gap-4 border-main ${pageDir === 'rtl' ? 'border-r-4' : 'border-l-4'}`}
          >
            {/* Instruction Number */}
            <div className="flex items-center justify-center bg-main text-white font-bold w-12 h-12 rounded-full text-lg">
              {index + 1}
            </div>

            {/* Content in French and Arabic */}
            <div className="w-full">
              <div
                className={`flex flex-col md:flex-row justify-between text-gray-700 text-sm md:text-base ${pageDir === 'rtl' ? 'text-right' : 'text-left'}`}
              >
                <p className="font-medium">{instruction.contentFr}</p>
                <p className="font-medium">{instruction.contentAr}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ShowInstructions;
